import { useEffect, useRef } from 'react';

const REVIEWS = [
  {
    name: '김민지',
    origin: '🇰🇷 서울',
    service: '반영구 눈썹 문신',
    rating: 5,
    text: '처음에 반영구 문신이 무서웠는데 원장님이 차근차근 설명해 주셔서 편안하게 시술 받았어요. 쑥뜸 케어가 포함되어 있어서 시술 후 회복도 빠르고, 완성된 눈썹이 너무 자연스러워서 매일 아침이 달라졌어요!',
    initials: '김',
    color: 'bg-plum',
    lang: 'KR',
  },
  {
    name: 'Sarah M.',
    origin: '🇺🇸 New York',
    service: 'Semi-Permanent Eyebrow',
    rating: 5,
    text: 'I was visiting Seoul and decided to try it here. The staff spoke perfect English and made me feel so comfortable. The results are stunning — my brows look so natural! The mugwort aftercare was such a unique and wonderful experience. 100% recommend!',
    initials: 'S',
    color: 'bg-gold-dark',
    lang: 'EN',
  },
  {
    name: '이수정',
    origin: '🇰🇷 인천',
    service: '안신환 + 청뇌환',
    rating: 5,
    text: '오랫동안 불면증으로 고생했는데 한의학 박사님이 체질을 꼼꼼하게 진단해 주셨어요. 안신환+청뇌환을 3주 복용 후 정말 편안하게 잠들게 됐어요. 명동에 이런 클리닉이 있다는 게 정말 신기해요. 너무 감사해요!',
    initials: '이',
    color: 'bg-plum-light',
    lang: 'KR',
  },
  {
    name: '田中さくら',
    origin: '🇯🇵 Tokyo',
    service: 'アイドルメイク',
    rating: 5,
    text: '明洞을 여행中に立ち寄りました！日本語でスタッフが丁寧に対応してくれて安心でした。アイドルメイクの仕上がり가完璧で、K-POPアイドルになった気分！ 艾灸ケアも初体験で感동。また絶対에来ます！',
    initials: '田',
    color: 'bg-gold',
    lang: 'JP',
  },
  {
    name: '王小雨',
    origin: '🇨🇳 Beijing',
    service: '半永久纹眉',
    rating: 5,
    text: '在明洞旅游时偶然发现了这家诊所，工作人员会说普通话，沟通完全没问题！眉毛做得非常自然，完全看不出来는纹의.艾灸护理는特别的 경험, 피부가 매우 편안해요. 강력 추천합니다!',
    initials: '王',
    color: 'bg-plum-dark',
    lang: '中',
  },
  {
    name: '박서연',
    origin: '🇰🇷 강남',
    service: '역노화 레이저',
    rating: 5,
    text: 'MICRO-JET 레이저 받고 나서 피부가 완전히 달라졌어요. 모공이 눈에 띄게 줄어들고 피부 결이 정말 고와졌어요. 원장님이 직접 상담해 주시는 점이 너무 믿음직스럽고, 시술 후 광채가 지속돼서 주변 지인들한테도 다 추천했어요.',
    initials: '박',
    color: 'bg-gold-dark',
    lang: 'KR',
  },
  {
    name: '최현우',
    origin: '🇰🇷 부산',
    service: '슬림 다이어트 한약',
    rating: 5,
    text: '남성인데도 전혀 불편함 없이 상담받았어요. 체질 분석 후 처방받은 다이어트 한약을 한 달 복용했더니 체중도 빠지고 무엇보다 속이 너무 개운해졌어요. 한의학 박사님이 계셔서 믿고 받을 수 있었어요.',
    initials: '최',
    color: 'bg-plum',
    lang: 'KR',
  },
  {
    name: 'Emma K.',
    origin: '🇬🇧 London',
    service: 'Reverse Aging Laser',
    rating: 5,
    text: 'Stumbled upon this gem while exploring Myeongdong — best decision ever! The blend of traditional Korean herbal medicine and modern beauty tech is truly unique. The doctor\'s expertise was impressive and the facility is immaculate. My skin has never looked better!',
    initials: 'E',
    color: 'bg-gold',
    lang: 'EN',
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-gold">
          <i className="ri-star-fill text-sm"></i>
        </span>
      ))}
    </div>
  );
}

function ReviewCard({ review }: { review: typeof REVIEWS[0] }) {
  return (
    <div className="flex-shrink-0 w-[340px] bg-white border border-gold/10 rounded-2xl p-6 mx-3">
      {/* Top */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-11 h-11 rounded-full ${review.color} flex items-center justify-center text-white font-serif text-lg font-bold flex-shrink-0`}>
            {review.initials}
          </div>
          <div>
            <p className="font-serif text-sm font-bold text-gray-900">{review.name}</p>
            <p className="font-sans text-xs text-gray-400">{review.origin}</p>
          </div>
        </div>
        <span className="text-xs font-sans font-semibold text-gold-dark bg-gold-pale px-2 py-0.5 rounded-full whitespace-nowrap">
          {review.lang}
        </span>
      </div>

      {/* Stars */}
      <StarRating count={review.rating} />

      {/* Quote */}
      <div className="mt-3 relative">
        <i className="ri-double-quotes-l text-2xl text-gold/20 absolute -top-1 -left-1"></i>
        <p className="font-sans text-sm text-gray-600 leading-relaxed pl-4 line-clamp-4">
          {review.text}
        </p>
      </div>

      {/* Service tag */}
      <div className="mt-4 pt-4 border-t border-gray-50 flex items-center gap-1.5">
        <i className="ri-checkbox-circle-fill text-gold text-sm"></i>
        <span className="font-sans text-xs text-gray-400">{review.service}</span>
      </div>
    </div>
  );
}

export default function ReviewsSection() {
  const ref = useRef<HTMLElement>(null);
  const track1Ref = useRef<HTMLDivElement>(null);
  const track2Ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1 }
    );
    const els = ref.current?.querySelectorAll('.section-reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // Split reviews into two rows
  const row1 = [...REVIEWS.slice(0, 4), ...REVIEWS.slice(0, 4)]; // duplicated for infinite loop
  const row2 = [...REVIEWS.slice(4), ...REVIEWS.slice(4)];

  return (
    <section id="reviews" ref={ref} className="bg-cream py-20 md:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-7 md:px-8">
        {/* Header */}
        <div className="text-center mb-14 md:mb-18 section-reveal">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-12 sm:w-16 bg-gold/50"></div>
            <span className="text-gold font-sans text-xs sm:text-sm font-semibold tracking-[0.2em] sm:tracking-[0.25em] uppercase">Reviews</span>
            <div className="h-px w-12 sm:w-16 bg-gold/50"></div>
          </div>
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-900 font-bold mb-3">고객 후기</h2>
          <p className="font-sans text-gray-400 text-xs sm:text-sm tracking-wide mb-5 sm:mb-6">
            Reviews · 顾客评价 · お客様の声
          </p>
          {/* Summary stats */}
          <div className="inline-flex flex-wrap items-center justify-center gap-4 sm:gap-6 bg-white border border-gold/15 rounded-2xl px-5 sm:px-8 py-3 sm:py-4">
            <div className="text-center">
              <div className="flex items-center gap-1 justify-center mb-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-gold">
                    <i className="ri-star-fill text-base"></i>
                  </span>
                ))}
              </div>
              <p className="font-serif text-2xl font-bold text-gray-900">5.0</p>
              <p className="font-sans text-xs text-gray-400">평균 별점</p>
            </div>
            <div className="w-px h-12 bg-gold/20"></div>
            <div className="text-center">
              <p className="font-serif text-2xl font-bold text-gray-900">100%</p>
              <p className="font-sans text-xs text-gray-400">재방문 의사</p>
            </div>
            <div className="w-px h-12 bg-gold/20"></div>
            <div className="text-center">
              <p className="font-serif text-2xl font-bold text-gray-900">한·EN·中·日</p>
              <p className="font-sans text-xs text-gray-400">다국어 후기</p>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee Row 1 — scrolls left */}
      <div className="section-reveal mb-4">
        <div
          ref={track1Ref}
          className="flex"
          style={{
            animation: 'marquee-left 30s linear infinite',
            width: 'max-content',
          }}
        >
          {row1.map((review, i) => (
            <ReviewCard key={`r1-${i}`} review={review} />
          ))}
        </div>
      </div>

      {/* Marquee Row 2 — scrolls right */}
      <div className="section-reveal">
        <div
          ref={track2Ref}
          className="flex"
          style={{
            animation: 'marquee-right 34s linear infinite',
            width: 'max-content',
          }}
        >
          {row2.map((review, i) => (
            <ReviewCard key={`r2-${i}`} review={review} />
          ))}
        </div>
      </div>

      {/* Marquee keyframes injected via style tag */}
      <style>{`
        @keyframes marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>

      <div className="max-w-6xl mx-auto px-5 md:px-6">
        <div className="mt-10 md:mt-12 section-reveal text-center">
          <button
            onClick={() => { const el = document.querySelector('#reservation'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-plum text-white px-8 py-3.5 rounded-full font-sans font-semibold text-sm cursor-pointer hover:bg-plum-dark transition-colors whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            나도 경험해보기 — 예약하기
          </button>
        </div>
      </div>
    </section>
  );
}
